// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"reset-contextmenu_contextMenu_3fxz8","resetStatus":"reset-contextmenu_resetStatus_26FaB","greenStatus":"reset-contextmenu_greenStatus_1D_P8"};